import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PrimeReactProvider } from 'primereact/api';


// PrimeReact theme (choose one)
import 'primereact/resources/themes/lara-light-blue/theme.css';
// PrimeReact core styles
import 'primereact/resources/primereact.min.css';
// PrimeIcons icons
import 'primeicons/primeicons.css';
// PrimeFlex utilities
import 'primeflex/primeflex.css';

// import 'quill/dist/quill.snow.css';

const primeReactConfig = {
  hideOverlaysOnDocumentScrolling: true
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PrimeReactProvider config={primeReactConfig}>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
